<div class="header_modal">
  <div class="header_modal-inner">
    <h3 class="green decoration mb-0">Organizaciones vinculadas — {{ data.title | uppercase }}</h3>
    <button mat-button type="button" class="btn btn-second" (click)="downloadExcel()">
      <mat-icon class="me-1">download</mat-icon>
      Exportar Excel
    </button>
  </div>
</div>

<div mat-dialog-content class="content_modal !pt-0">
  <div class="table__responsive modal">
    <div class="table-wrapper">
      <div class="table-wrapper-inner limited">
        <table mat-table [dataSource]="data.arrivedData" class="not-wrap">

          <ng-container matColumnDef="organization_name">
            <th mat-header-cell *matHeaderCellDef>Organización</th>
            <td mat-cell *matCellDef="let org">{{ org.organization_name || '---' }}</td>
          </ng-container>

          <ng-container matColumnDef="product_name">
            <th mat-header-cell *matHeaderCellDef>Producto</th>
            <td mat-cell *matCellDef="let org">{{ org.product_name || 'overall' }}</td>
          </ng-container>

          <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef>Estado</th>
            <td mat-cell *matCellDef="let org">
              <div class="badge">
                <span [ngClass]="{'success': org.status === 'active', 'pending': org.status === 'onboarding' || !org.status}">
                  {{ org.status || 'onboarding' }}
                </span>
              </div>
            </td>
          </ng-container>

          <ng-container matColumnDef="previous_state">
            <th mat-header-cell *matHeaderCellDef>Estado Previo</th>
            <td mat-cell *matCellDef="let org">{{ org.previous_state || 0 }}</td>
          </ng-container>

          <ng-container matColumnDef="date">
            <th mat-header-cell *matHeaderCellDef>Fecha Creación</th>
            <td mat-cell *matCellDef="let org">{{ org.date ? (org.date | date:'dd/MM/yyyy') : '---' }}</td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

          <tr class="mat-row" *matNoDataRow>
            <td class="mat-cell text-center" colspan="5">No se encontraron registros de organizaciones vinculadas.</td>
          </tr>

        </table>
      </div>
    </div>
  </div>
</div>

<div mat-dialog-actions class="!m-0 w-full block">
  <div class="w-full flex justify-end actions_modal">
    <button mat-button type="button" (click)="close()" class="btn btn-primary big">Cerrar</button>
  </div>
</div>
